import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import {  Router } from "@angular/router";
import { Subject } from "rxjs";
import { CookieService } from '../Services/cookie';
import { AccountService } from '../Services/account.service';
import { AuthService } from '../Services/auth.service';
import { CommonService } from '../Services/common.service';
import { InsuranceService } from '../Services/insurance.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-insurance-claims',
  templateUrl: './insurance-claims.component.html',
  standalone:false,
  styleUrls: ['./insurance-claims.component.scss']
})
export class InsuranceClaimsComponent implements OnInit {
  modalObservable: Subject<void> = new Subject<void>();

  proposalId: string;
  ClaimList: any[]=[];
  ClaimDet: any[]=[];

  constructor(private router: Router,private acct:AccountService,private location: Location, private insurance:InsuranceService, private common: CommonService,    private cookieService: CookieService,
    public auth:AuthService,private _sanitizer: DomSanitizer) {}
    
 async ngOnInit(): Promise<any> {

  this.common.presentLoading();
//   this.ImgUrl = this.inspectionDetails.reportImage;
// this.base64Image = this._sanitizer.bypassSecurityTrustResourceUrl(this.ImgUrl);
   this.auth.accessToken = await this.common.Get("token");
   this.auth.VerifyToken({}, this.auth.accessToken).then(async (data: any) => {
    if (data?.response?.code == 1) {
      this.insurance.GetClaimsList(this.proposalId,this.auth.accessToken).then((res: any) => {

        if (res?.response?.code == 1) {

          res.response.content.claimsDocuments.forEach(element => {
             element.icons = this._sanitizer.bypassSecurityTrustResourceUrl("data:image/svg+xml;base64,"+element.icons);
          });
          this.ClaimList = res.response.content.claimsDocuments;

         this.ClaimDet =  res.response.content.claimsContactDetails;
  
          console.log("this.ClaimList", this.ClaimList);
          this.common.hideLoading();
        }
        else {
          this.common.hideLoading();
          this.common.ParseErrorAlert("", "OK", this.router, res);
        }
      })
  }
  else {
    await this.common.hideLoading();
    this.common.ParseErrorAlert("", "", this.router, data);
  }

  })


    let a =await this.cookieService.get("proposalId", true);

    if (a) {

      this.proposalId = a;

    }
    // if(this.proposalId != "" && this.proposalId != undefined){
  
      
    // }
  }



  back() {
    this.location.back()
  }

  showModal(num) {
    this.modalObservable.next(num);
    this.cookieService.delete("proposalId");

  }

}
